import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const AnimationSlideBottom = ({ children, duration,rootMargin }) => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2,
    rootMargin: rootMargin,
  });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: -20 }} // Start out of view
      animate={inView ? { opacity: 1, y: 0 } : {}} // Animate into view
      transition={{ duration: duration, ease: "easeOut" }}
    >
      {children}
    </motion.div>
  );
};

export default AnimationSlideBottom